/**
 * FRONSYSTEM 4.1: диагностика сбоев API только в development (без шума и сырого текста в проде).
 * Контекст — на русском (как и пользовательский UI по STYLESYSTEM); это не текст для toast, а метка в консоли.
 */
import { apiRejectPayload } from './apiRejectPayload';

const IS_DEV = process.env.NODE_ENV === 'development';

/**
 * @param {string} context — короткая метка экрана/операции (русский)
 * @param {unknown} error — обычно AxiosError
 */
export function devLogApiError(context, error) {
  if (!IS_DEV) return;
  const { message, status } = apiRejectPayload(error);
  console.warn(`[сбой API: ${context}]`, message, status != null ? `(код HTTP ${status})` : '', error);
}
